import type { ApiRequest, ApiRequestWith } from "@/api/types";
import { httpPublic } from "@/api/httpPublic";
import type { PolicyMetaData, PracticeNameResponse, UUID } from "@/core/types";

type PublicRequestsTyped = {
  get_policy_metadata: ApiRequest<PolicyMetaData>;
  get_practice_name: ApiRequestWith<PracticeNameResponse, { searchParams: { practiceId: UUID } }>;
};

export const publicRequestsTyped: PublicRequestsTyped = {
  get_policy_metadata: function ({ context } = {}) {
    return httpPublic.get("/v1/public/get_policy_metadata", { context }).json<PolicyMetaData>();
  },
  get_practice_name: function ({ context, searchParams }) {
    return httpPublic
      .post("/v1/a5_screening/get_practice_name", {
        context,
        searchParams,
      })
      .json<PracticeNameResponse>();
  },
};
